
/****   http.js   ****/
// 导入封装好的axios实例
import axios from 'axios'
import router from '@/router';
import { Message } from 'element-ui';
import service from '@/utils/request';
// const preUrl="http://124.222.41.47:8080/"
//创建一个新的axios实例
const uploadService = axios.create({
    baseURL:"https://www.zjrbl.com:8443/",
    //设置超时时间，超过该时间就不会发起请求
    timeout:5000
})
const httpAxios = axios.create({
    baseURL:"https://www.zjrbl.com:8443/",
    //设置超时时间，超过该时间就不会发起请求
    timeout:5000
})
 export const  baseUrl = 'https://www.zjrbl.com:8443/'
// httpAxios.interceptors.request.use(
//
//     config=>{
//         //？？？？？
//         config.headers = {
//             'Content-Type':'application/json' //配置请求头
//         };
//
//         const  token =JSON.parse(localStorage.getItem('token_info')).token
//         const  uid =JSON.parse(localStorage.getItem('token_info')).uid
//         if(typeof token == "undefined" || token == null || token == ""){
//         }else {
//             if (config.isToken){
//                 config.headers["token"]= token
//                 config.headers["uid"]= uid
//             }
//
//
//         }
//
//         return config
//     },
//     error=>{
//         console.log(error);
//         return Promise.reject(error)
//     }
// )
httpAxios.interceptors.response.use(
    //请求成功处理
    response=>{

        const res=response.data
        if(res.code===0){
            return res
        }
        //token 失效
        if (res.code == 500){
            localStorage.removeItem('ms_username');
            router.push("/login")
            Message.error(res.msg)
            return res
        }
        else{
            Message.error(res.msg)
            return res
        }

    })
const nHttp ={
    getDownLoadUrl(){
        return "https://www.zjrbl.com:8443/file/"
    },
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params){
        url=url+'?';
        for (let key in params){
            url+=key+'='+params[key]+'&'
            console.log(key+""+params[key])
        }

        return httpAxios.get(url)
    },

    getToken(url,params){
        if (url.charAt(url.length-1)!='?'){
            url+="?"
        }
       const keys= Object.keys(params)
        keys.forEach(key=>{
            url+=key+'='+params[key]+'&'

        })
        const  token =JSON.parse(localStorage.getItem('token_info')).token
        const  uid =JSON.parse(localStorage.getItem('token_info')).uid
        url = url.substr(0, url.length - 1);
        return httpAxios.get(url,{
            headers: {'token': token,'uid': uid}})
    },
    post(url,params){

        return httpAxios.post(url,params)
    },

    postToken(url,params){
        const  token =JSON.parse(localStorage.getItem('token_info')).token
        const  uid =JSON.parse(localStorage.getItem('uid'))

        return httpAxios.post(url,params,{
            headers: {'token': token,'uid': uid}})
    },
    put(url,params){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    delete(url,params){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    postFile(url,file){
        // 在这里进行一系列的校验
        const formData = new FormData();
        formData.append("files",file);

        return  uploadService.post(url,formData,{
            'Content-type' : 'multipart/form-data'
        })

    },
    postFileAndUserPool(url,file,type,uid){
        // 在这里进行一系列的校验
        const formData = new FormData();
        formData.append("file",file);
        formData.append("type",type);
        formData.append("uid",uid);
        return  uploadService.post(url,formData,{
            'Content-type' : 'multipart/form-data'
        })

    }
}
//导出
export default nHttp